import parse, { Element, DOMNode, domToReact } from 'html-react-parser';
import { cloneElement, ReactElement } from 'react';

export const parseAndReplaceHtmlTags = (html: string, tag: string, replacement: ReactElement) => {
  if (!html) {
    return null;
  }
  const options = {
    replace: (domNode: DOMNode) => {
      if (domNode instanceof Element) {
        if (domNode.name === tag) {
          return cloneElement(replacement, replacement.props, domToReact(domNode.children, options));
        }
      }

      return domNode;
    },
  };

  return parse(html, options) as ReactElement;
};
